<!DOCTYPE html>
<html lang="vi">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Chính sách bảo mật thông tin – 11N02</title>
  <link rel="stylesheet" href="info-privacy-policy.component.scss" />
</head>
<body>

<div class="policy">
  <div class="policy__content">

    <h1 class="policy__title">Chính sách bảo mật thông tin</h1>
    <p class="policy__subtitle">Áp dụng cho nền tảng Sàn giao dịch thương mại điện tử 11N02</p>
    <hr class="policy__divider" />

    <h2>I) Mục đích thu thập thông tin cá nhân</h2>

    <p>Sàn 11N02 thu thập thông tin cá nhân của người tiêu dùng cho các mục đích sau:</p>
    <ul>
      <li>Đăng ký tài khoản và sử dụng dịch vụ của Sàn 11N02.</li>
      <li>Xác thực, quản lý tài khoản thành viên và hỗ trợ người dùng trong quá trình sử dụng Website.</li>
      <li>Cung cấp dịch vụ theo yêu cầu của người tiêu dùng.</li>
      <li>Thực hiện các nghĩa vụ của Sàn 11N02 theo quy định của pháp luật.</li>
    </ul>

    <p>Sàn 11N02 thu thập thông tin cá nhân của người tiêu dùng gồm các mục:</p>
    <ul>
      <li>Các thông tin bắt buộc mà 11N02 cần thành viên cung cấp khi đăng ký tài khoản gồm: Họ và tên, email, số điện thoại.</li>
      <li>Các thông tin liên quan đến địa chỉ của khách hàng để có thể đặt hàng, gồm: Họ và tên người nhận hàng, địa chỉ nhận hàng, số điện thoại của người nhận hàng <em>(Các thông tin này người tiêu dùng nhập khi đặt hàng, tại trang Thanh toán đơn hàng).</em></li>
      <li>Các thông tin liên quan đến tài khoản người dùng, số đo cá nhân, danh sách yêu thích, thiết kế đã tạo và các thông tin khác do người dùng tự cung cấp khi cập nhật hồ sơ tài khoản hoặc sử dụng các chức năng tương ứng trên Website.</li>
      <li>Các thông tin liên quan đến đơn hàng, thanh toán, giao nhận, phản ánh, khiếu nại hoặc yêu cầu hỗ trợ do người dùng cung cấp trong quá trình sử dụng Website 11N02.</li>
      <li>Thông tin cá nhân được thu thập tại các chức năng tương ứng trên Website, bao gồm: khi người dùng đăng ký tài khoản; khi đăng nhập và cập nhật thông tin tại mục tài khoản/cài đặt; khi nhập địa chỉ nhận hàng tại trang thanh toán; khi cập nhật số đo cá nhân; khi tạo thiết kế sản phẩm; khi đặt hàng, thanh toán; và khi người dùng gửi phản ánh, khiếu nại hoặc yêu cầu hỗ trợ đến Sàn 11N02.</li>
    </ul>

    <p><strong>Phương thức thu thập thông tin cá nhân:</strong> Người tiêu dùng tự cung cấp thông tin cá nhân khi đăng ký tài khoản và sử dụng dịch vụ của 11N02. Chính sách bảo vệ thông tin cá nhân này được hiển thị công khai trên Website và được thông báo cho người tiêu dùng trước hoặc tại thời điểm hệ thống thu thập thông tin cá nhân.</p>

    <h2>II) Phạm vi sử dụng thông tin cá nhân</h2>

    <p>11N02 sử dụng thông tin cá nhân của người tiêu dùng trong phạm vi cần thiết để:</p>
    <ul>
      <li>Cung cấp dịch vụ trên Website;</li>
      <li>Xác thực, quản lý và hỗ trợ tài khoản thành viên;</li>
      <li>Xử lý đơn hàng, thanh toán, giao nhận, đổi trả, hoàn tiền và các giao dịch phát sinh trên Website;</li>
      <li>Liên hệ, phản hồi các yêu cầu, phản ánh, khiếu nại của người dùng;</li>
      <li>Thực hiện các nghĩa vụ theo quy định của pháp luật.</li>
    </ul>

    <p>11N02 cam kết không bán, không chia sẻ và không tiết lộ thông tin cá nhân của người tiêu dùng cho bên thứ ba nếu không có sự đồng ý của người tiêu dùng, trừ trường hợp pháp luật có quy định khác hoặc cơ quan nhà nước có thẩm quyền yêu cầu.</p>

    <h2>III) Thời gian lưu trữ thông tin cá nhân</h2>

    <p>Sàn 11N02 sẽ lưu trữ thông tin cá nhân của người tiêu dùng trong thời gian cần thiết để cung cấp dịch vụ và thực hiện các nghĩa vụ của mình theo quy định của pháp luật. Sau khi không còn cần thiết, 11N02 sẽ xóa hoặc làm ẩn thông tin cá nhân của khách hàng.</p>

    <h2>IV) Những người hoặc tổ chức có thể được tiếp cận với thông tin</h2>

    <p>Thông tin cá nhân của người tiêu dùng có thể được tiếp cận bởi các chủ thể sau đây trong phạm vi cần thiết:</p>
    <ul>
      <li>Công ty Cổ phần Digital and Stock là đơn vị vận hành Website 11N02;</li>
      <li>Bộ phận quản trị, chăm sóc khách hàng, kỹ thuật, kế toán và các bộ phận có liên quan của 11N02 trong phạm vi cần thiết để vận hành hệ thống, hỗ trợ người dùng, xử lý đơn hàng, đối soát, thanh toán và xử lý các vấn đề phát sinh;</li>
      <li>Người bán/Nhà cung cấp trên 11N02 trong phạm vi cần thiết để tiếp nhận, xử lý đơn hàng, chuẩn bị sản phẩm và phối hợp giải quyết các vấn đề phát sinh;</li>
      <li>Đơn vị vận chuyển, nhân viên giao nhận trong phạm vi cần thiết để thực hiện việc giao nhận hàng hóa theo thông tin đơn hàng;</li>
      <li>Cơ quan nhà nước có thẩm quyền khi có yêu cầu theo quy định của pháp luật.</li>
    </ul>

    <p>Ngoài các trường hợp nêu trên, 11N02 không cung cấp thông tin cá nhân của người tiêu dùng cho bên thứ ba nếu không có sự đồng ý của người tiêu dùng, trừ trường hợp pháp luật có quy định khác.</p>

    <h2>V) Địa chỉ của đơn vị thu thập và quản lý thông tin</h2>

    <p>Nếu có bất kỳ câu hỏi hoặc cần hỗ trợ gì về hoạt động thu thập, xử lý thông tin liên quan đến khách hàng, xin vui lòng liên hệ trực tiếp, điện thoại hoặc email của 11N02 theo thông tin dưới đây:</p>
    <ul>
      <li><strong>Tên tổ chức:</strong> Công ty cổ phần DIGITAL AND STOCK</li>
      <li><strong>Địa chỉ:</strong> 185A-185B Đường Hà Huy Giáp, Phường Thạnh Lộc, Quận 12, Thành phố Hồ Chí Minh, Việt Nam</li>
      <li><strong>Email:</strong> <a href="mailto:11N02@gmail.com">11N02&#64;com</a></li>
      <li><strong>Điện thoại:</strong> <a href="tel:0901110102">0901110102</a></li>
    </ul>

    <h2>VI) Phương thức và công cụ để người tiêu dùng tiếp cận và chỉnh sửa dữ liệu cá nhân của mình</h2>

    <p>Để được tiếp cận và chỉnh sửa dữ liệu cá nhân của mình thì người dùng phải là cá nhân/tổ chức đã đăng ký thành viên 11N02. Theo đó, người dùng đăng nhập Sàn 11N02 và có thể chỉnh sửa dữ liệu cá nhân của mình tại Trang Hồ sơ tài khoản, trong mục <strong>Cài đặt</strong>.</p>
    <p>Trường hợp cần hỗ trợ, người dùng có thể liên hệ với 11N02 qua số điện thoại hoặc email được công bố trên Website để được hướng dẫn.</p>

    <h2>VII) Cam kết bảo mật thông tin cá nhân khách hàng</h2>

    <p>Chúng tôi cam kết sẽ bảo mật các thông tin cá nhân của khách hàng, nỗ lực hết sức và sử dụng các biện pháp thích hợp để các thông tin mà khách hàng cung cấp trong quá trình sử dụng Sàn 11N02 được bảo mật.</p>

    <p>11N02 cam kết đảm bảo an toàn, an ninh cho thông tin cá nhân đã thu thập và lưu trữ từ khách hàng, đồng thời cam kết ngăn ngừa các hành vi sau:</p>
    <ul>
      <li>Đánh cắp hoặc tiếp cận thông tin trái phép;</li>
      <li>Sử dụng thông tin trái phép;</li>
      <li>Thay đổi, phá hủy thông tin trái phép.</li>
    </ul>

    <p>Thông tin cá nhân của thành viên trên Sàn được Ban quản lý 11N02 cam kết bảo mật theo chính sách bảo vệ thông tin cá nhân của Sàn 11N02. Việc thu thập và sử dụng thông tin của mỗi thành viên chỉ được thực hiện khi có sự đồng ý của khách hàng đó trừ những trường hợp pháp luật có quy định khác. Không sử dụng, không chuyển giao, cung cấp hay tiết lộ cho bên thứ ba nào về thông tin cá nhân của thành viên khi không có sự cho phép đồng ý từ thành viên.</p>

    <p>Ban quản lý 11N02 yêu cầu các cá nhân khi đăng ký là thành viên phải cung cấp đầy đủ thông tin cá nhân có liên quan như: họ và tên, địa chỉ, email, điện thoại… và chịu trách nhiệm về tính pháp lý của những thông tin trên.</p>

    <h2>VIII) Cơ chế tiếp nhận và giải quyết khiếu nại liên quan đến thông tin cá nhân khách hàng</h2>

    <p>Người tiêu dùng có quyền gửi khiếu nại liên quan đến việc thông tin cá nhân bị thu thập, sử dụng sai mục đích, sử dụng vượt quá phạm vi đã thông báo hoặc bị tiết lộ, sử dụng trái phép đến Ban quản lý Sàn 11N02.</p>

    <p>Sau khi tiếp nhận phản ánh, Ban quản lý Sàn 11N02 sẽ tiến hành xác minh thông tin, phối hợp với các bộ phận liên quan để kiểm tra và đưa ra phương án xử lý phù hợp nhằm bảo đảm quyền lợi của người dùng.</p>

    <p>Trong trường hợp hệ thống lưu trữ thông tin xảy ra sự cố như bị truy cập trái phép hoặc bị tấn công dẫn đến nguy cơ lộ thông tin cá nhân của người dùng, 11N02 sẽ kịp thời thông báo cho cơ quan chức năng có thẩm quyền để phối hợp xử lý theo quy định của pháp luật, đồng thời thông báo cho người dùng bị ảnh hưởng để có biện pháp bảo vệ thông tin cá nhân.</p>

    <p>Việc tiếp nhận và giải quyết khiếu nại sẽ được thực hiện như sau:</p>

    <p><strong>Bước 1:</strong> Người dùng gửi khiếu nại qua email <a href="mailto:11N02@gmail.com">11N02&#64;com</a> hoặc gọi điện thoại vào số hotline <a href="tel:0901110102">0901110102</a> để được hướng dẫn.</p>

    <p><strong>Bước 2:</strong> Sau khi tiếp nhận khiếu nại, 11N02 tiến hành kiểm tra, xác minh thông tin. Đối với trường hợp đơn giản, bộ phận chăm sóc khách hàng sẽ hỗ trợ xử lý ngay. Đối với các trường hợp còn lại, thời gian xử lý tối đa là 05 ngày làm việc kể từ ngày tiếp nhận đầy đủ thông tin cần thiết.</p>

    <p><strong>Bước 3:</strong> Kết quả xử lý khiếu nại được thông báo cho người dùng qua số điện thoại hoặc địa chỉ email đã đăng ký hoặc đã cung cấp khi gửi khiếu nại.</p>

    <hr />
    <p class="policy__footer">© 11N02. Mọi quyền được bảo lưu.</p>

  </div>
</div>

</body>
</html>